import React from "react";
import {
  CardContainer,
  CardImage,
  CardGradientThumb,
  CardTitle,
} from "./styles";

const CarouselCard = ({ project, isSelected, onClick, variants, custom, initial, animate }) => {
  return (
    <CardContainer
      variants={variants}
      custom={custom}
      initial={initial}
      animate={animate}
      isSelected={isSelected}
      accent={project.gradient.accent}
      bg={isSelected ? "#1a1a1a" : "#0d0d0d"}
      onClick={onClick}
    >
      {project.image ? (
        <CardImage src={project.image} alt={project.title} />
      ) : (
        <CardGradientThumb gradient={project.gradient.background} />
      )}
      <CardTitle>{project.title}</CardTitle>
    </CardContainer>
  );
};

export default React.memo(CarouselCard);
